import {createAsyncThunk} from '@reduxjs/toolkit'

import {getCardReRegisterUrl} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'
import {LanguageType} from '@web/i18n'

import {LocationChangeHistoryParam, NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

/**
 * 외국인 대상 카드 재등록 페이지로 이동
 */
const navigateToCardReRegister = createAsyncThunk<
    NavigationResult,
    {language: LanguageType} & ((NavigationTypeSelectableParam & LocationChangeHistoryParam) | void),
    ThunkApi
>('navigateTo/cardReRegister', async (args) => {
    const {forceLocationChange = false, historyType = 'PUSH'} = args ?? {}
    const shouldChangeLocation = forceLocationChange || isMobile
    const url = getCardReRegisterUrl({language: args.language})

    if (shouldChangeLocation) {
        changeBrowserLocation({
            url,
            type: historyType,
        })
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    openNewTab({url})
})

export default navigateToCardReRegister
